<template>
    <div id="inventory_page">
        <div class="inventory_page_con">
            <div class="user_info flex jb ac">
                <div class="text flex  ac">
                    <img :src="userInfo.avatarurl?userInfo.avatarurl:'/static/img/default-avatar.png'"
                         class="avatar" />
                    <div class="name">
                        <p>{{userInfo.nickname}}</p>
                        <span>{{userInfo.vip_name}} | {{userInfo.vip_end_date}}</span>
                    </div>
                </div>
                <div class="points">
                    <img src="./img/icon_img44.png"
                         class="big_img" />
                    <p class="flex ac"><img src="./img/icon_img43.png" />积分：{{ userInfo.score_balance }}</p>
                </div>
            </div>
            <div class="strong_title">积分记录</div>
            <div class="points_list">
                <div class="tab_list flex ac">
                    <div class="tab_list_item"
                         :class="active_tab==index?'active':''"
                         @click="choose_tab(index)"
                         v-for="(item,index) in tab_list"
                         :key="index">{{item.name}}</div>
                </div>
                <div class="tab_con">
                    <div class="tab_con_title flex jb ac">
                        <p>事件</p>
                        <p>积分变换</p>
                        <p>发生时间</p>
                    </div>
                    <div class="tab_con_table">

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            tab_list: [
                {
                    id: 1,
                    name: '充值/领取'
                },
                {
                    id: 2,
                    name: '消费'
                }
            ],
            active_tab: 0,
        }
    },
    computed: {
        userInfo () {
            return this.$store.state.userInfo;
        },
        isLogin(){
            return this.$store.state.isLogin;
        }
    },
    methods: {
        choose_tab (index) {
            this.active_tab = index
        },
        back () {

        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#inventory_page {
    background: #131414;
    padding: 40px 0;
    height: 100%;
    .inventory_page_con {
        margin: 0 auto;
        max-width: 1000px;
        max-width: 1000px;
    }
    .user_info {
        padding: 32px 80px;
        background: #212123;
        border-radius: 20px;
        .text {
            flex: 0 0 50%;
            .avatar {
                width: 74px;
                height: 74px;
                border-radius: 100%;
                margin-right: 12px;
            }
            .name {
                p {
                    font-size: 14px;
                    color: #fff;
                    margin-bottom: 5px;
                }
                span {
                    font-size: 12px;
                    color: #6c6c6c;
                }
            }
        }
        .points {
            flex: 0 0 50%;
            position: relative;
            p {
                font-size: 14px;
                color: #fff;
                justify-content: center;
                img {
                    width: 34px;
                    height: 34px;
                    margin-right: 5px;
                }
            }
            .big_img {
                position: absolute;
                right: -80px;
                top: 50%;
                transform: translateY(-50%);
                width: 132px;
                height: 132px;
            }
        }
    }
    .strong_title {
        font-size: 14px;
        color: #fff;
        font-weight: bold;
        margin: 30px 0 20px 0;
    }
    .points_list {
        background: #212123;
        padding: 30px 35px;
        border-radius: 8px;
        .tab_list {
            margin-bottom: 20px;
            .tab_list_item {
                font-size: 14px;
                font-weight: bold;
                color: #808080;
                margin-right: 20px;
                border-bottom: 3px solid transparent;
                cursor: pointer;
                &.active {
                    color: #fff;
                    border-color: #5c69f2;
                }
            }
        }
        .tab_con {
            .tab_con_title {
                background: #2b2d31;
                P {
                    padding: 0 23px;
                    font-size: 14px;
                    color: #fff;
                    font-weight: bold;
                    line-height: 50px;
                    text-align: center;
                    &:nth-child(1) {
                        flex: 0 0 20%;
                    }
                    &:nth-child(2) {
                        flex: 0 0 50%;
                    }
                    &:nth-child(3) {
                        flex: 0 0 30%;
                    }
                }
            }
            .tab_con_table {
                min-height: 320px;
                overflow-y: scroll;
            }
        }
    }
}
</style>